import { useGlobalStore } from '@/common/globalStore';

import { IS_PROD_ENV, IS_TEST_ENV } from './config';

export type RemoteFeatureToggles = {
  /**
   * IDs of users that are allowed to use schedule import feature
   */
  importUserIds: string[];
};

export const remoteFeatureToggles = ref<RemoteFeatureToggles>({ importUserIds: [] });

const CAP_DISABLED_TENANT_IDS = [
  'VGVuYW50Tm9kZTo0NDA=', // Instone
  'VGVuYW50Tm9kZTo1OTA=', // NYOO
];

export function useFeatureToggles() {
  const toggles = {
    ENABLE_PRODUCTION_LOGGING_ON_DEV: false,
    ENABLE_STAGING_LOGGING_ON_DEV: false,
    ENABLE_CAP: computed(() => {
      const globalStore = useGlobalStore();

      if (!globalStore.currentTenantId) return false;

      if (CAP_DISABLED_TENANT_IDS.includes(globalStore.currentTenantId)) return false;

      return true;
    }),
    ENABLE_CAP_THRESHOLDS: computed(() => {
      const globalStore = useGlobalStore();

      if (!globalStore.currentTenantId) return false;

      if (CAP_DISABLED_TENANT_IDS.includes(globalStore.currentTenantId)) return false;

      return !IS_PROD_ENV && !IS_TEST_ENV;
    }),
    enableProjectScheduleImport: (user: { email: string; id: string }) => {
      return computed(() => {
        if (user.email.endsWith('@koppla.de')) return true;

        return remoteFeatureToggles.value.importUserIds.includes(user.id);
      });
    },
  };
  if (IS_PROD_ENV) {
    return toggles;
  }
  Object.keys(toggles).forEach((toggleKey) => {
    try {
      const localStorageValue = localStorage.getItem(toggleKey);
      if (localStorageValue !== null) {
        toggles[toggleKey] = localStorageValue === 'true';
      }
    } catch {
      // Local Storage is disabled.
    }
  });
  return toggles;
}

export type FeatureToggles = ReturnType<typeof useFeatureToggles>;
